import api from './HttpService';
import { CURRENCY } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  try {
    const res = await api.get(CURRENCY.LIST + query);
    return res;
  } catch (error) {
    return error; // Rethrow the error to propagate it further
  }
}

async function getCurrencyList(postData) {
  const res = await api.get(CURRENCY.LIST_ALL_CURRENCY, postData);
  return res;
}

async function add(postData) {
  const res = await api.post(CURRENCY.ADD, postData);
  return res;
}

async function getItem(code) {
  const res = await api.get(`${CURRENCY.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.patch(`${CURRENCY.UPDATE}/${code}`, postData);
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${CURRENCY.DELETE}/${code}`);
  return res;
}

async function getActiveItem() {
  const res = await api.get(`${CURRENCY.ACTIVE}`);
  return res;
}

const CurrencyService = {
  getAll,
  getCurrencyList,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem
};

export default CurrencyService;
